import PdaTitle from '../../component/common/PdaTitle'
import React, { useState } from 'react'
import { TabPanel, TabView } from 'primereact/tabview'
import PdaIconTabHeader from '../../component/common/PdaIconTabHeader'
import IncomingKeepGoods from '../../component/incoming/IncomingKeepGoods'
import IncomingDayGoods from '../../component/incoming/IncomingDayGoods'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const Incoming = () => {
    const { t } = useTranslation()
    const [activeIndex, setActiveIndex] = useState<number>(0)
    return (
        <div>
            <PdaTitle title={t(tokens.common.incoming_schedule_list)} historyBack goToHome />
            <div className="mt-1 overflow-y-scroll p-3 pt-1">
                {activeIndex === 0 ? <IncomingKeepGoods /> : null}
            </div>
            {/*<TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} pt={{ panelContainer: { className: 'p-2' } }}>
                <TabPanel header={<PdaIconTabHeader icon="pi-home" title={t(tokens.common.stored_inventory)} />}>
                    {activeIndex === 0 ? <IncomingKeepGoods /> : null}
                </TabPanel>
                <TabPanel header={<PdaIconTabHeader icon="pi-truck" title={t(tokens.common.daily_inventory)} />}>
                    {activeIndex === 1 ? <IncomingDayGoods /> : null}
                </TabPanel>
            </TabView>*/}
        </div>
    )
}

export default Incoming
